<div class="password-reset-container">
  <div class="card">
    <div class="flex align-items-center mb-4">
      <i class="pi pi-lock text-primary text-xl mr-2"></i>
      <h3 class="text-xl font-semibold text-900 m-0">Password Reset</h3>
    </div>

    <p class="text-600 mb-4">
      Request a password reset link to be sent to your email address. You can only reset your own
      password.
    </p>

    <form [formGroup]="passwordResetForm" (ngSubmit)="onSubmit()" *ngIf="!resetRequested">
      <div class="field mb-4">
        <label for="email" class="block text-900 font-medium mb-2">Email Address</label>
        <input
          id="email"
          type="email"
          pInputText
          formControlName="email"
          class="w-full"
          placeholder="Enter your email address"
          [class.ng-invalid]="submitted && f['email'].errors"
          [class.ng-dirty]="submitted && f['email'].errors"
        />
        <small class="p-error block mt-1" *ngIf="submitted && f['email'].errors?.['required']">
          Email is required
        </small>
        <small class="p-error block mt-1" *ngIf="submitted && f['email'].errors?.['email']">
          Please enter a valid email address
        </small>
      </div>

      <div class="flex gap-2">
        <button
          type="submit"
          pButton
          label="Request Password Reset"
          icon="pi pi-send"
          [loading]="loading"
          [disabled]="loading"
          class="p-button-primary"
        ></button>
        <button
          type="button"
          pButton
          label="Reset Form"
          icon="pi pi-refresh"
          (click)="resetForm()"
          class="p-button-secondary"
        ></button>
      </div>
    </form>

    <div *ngIf="resetRequested" class="success-message">
      <div class="flex align-items-center mb-3">
        <i class="pi pi-check-circle text-green-500 text-xl mr-2"></i>
        <h4 class="text-green-500 font-semibold m-0">Password Reset Requested</h4>
      </div>
      <p class="text-600 mb-4">
        A password reset link has been sent to <strong>{{ f['email'].value }}</strong
        >. Please check your email and follow the instructions to reset your password.
      </p>
      <div class="bg-blue-50 border-round p-3 mb-4">
        <div class="flex align-items-start">
          <i class="pi pi-info-circle text-blue-500 mt-1 mr-2"></i>
          <div>
            <p class="text-blue-700 font-medium mb-1">Important Notes:</p>
            <ul class="text-blue-600 text-sm m-0 pl-3">
              <li>The reset link will expire after a certain time period</li>
              <li>Check your spam folder if you don't see the email</li>
              <li>Contact support if you continue to have issues</li>
            </ul>
          </div>
        </div>
      </div>
      <button
        type="button"
        pButton
        label="Request Another Reset"
        icon="pi pi-refresh"
        (click)="resetForm()"
        class="p-button-outlined"
      ></button>
    </div>
  </div>
</div>
